import { useEffect, useState } from "react";

/**
 * Hook for modal open/close animations.
 * Returns `mounted` (keep in DOM) and `closing` (play exit animation).
 * Modal should render when `mounted` is true.
 * Apply the closing class/state to trigger fade-out animation.
 * After the animation duration, the component unmounts.
 */
export const useModalAnimation = (open: boolean, duration = 250) => {
  const [mounted, setMounted] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (open) {
      setClosing(false);
      setMounted(true);
    } else if (mounted) {
      setClosing(true);
      const timer = setTimeout(() => {
        setMounted(false);
        setClosing(false);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [open]);

  return { mounted, closing };
};
